module.exports = __webpack_public_path__ + "img/text_color.25598755.svg";